var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.type == 4)?_c('el-image',{ref:"pic",staticClass:"info-pic",attrs:{"src":_vm.src,"preview-src-list":_vm.imgList}}):_c('img',{staticClass:"info-pic",attrs:{"src":_vm.iconSrc},on:{"click":_vm.openUrl}})
}
var staticRenderFns = []

export { render, staticRenderFns }